<script>
export default {
    name: 'IlluDiplome',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-diplome"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M32 32c-3.829 0-7.367 1.22-10.235 3.286-2.895 2.087-5.107 5.037-6.239 8.464 1.133 3.428 3.344 6.378 6.24 8.464A17.451 17.451 0 0032 55.5c3.829 0 7.367-1.22 10.235-3.286 2.895-2.086 5.107-5.035 6.24-8.463-1.133-3.428-3.344-6.378-6.24-8.465A17.451 17.451 0 0032 32zm0-17.5a6.67 6.67 0 00-4.688 1.907A6.419 6.419 0 0025.374 21c0 1.794.74 3.418 1.938 4.593A6.67 6.67 0 0032 27.5a6.67 6.67 0 004.689-1.907A6.419 6.419 0 0038.626 21c0-1.794-.74-3.418-1.937-4.593A6.67 6.67 0 0032 14.5z"
                :stroke="secondaryColor" class="secondary-color"
            />
            <path
                d="M32 8l12 5-12 6-10-5 .001 4.134a1 1 0 01.492.75L22.5 19a1 1 0 11-1.5-.866V13.5l-1-.5 12-5z"
                :fill="primaryColor" class="primary-color"
            />
        </g>
    </svg>
</template>
